const UPDATE_CHECKER_INTERVAL = 30000;
export default async function checkForUpdate(context, err, firstTime = true) {
  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      registration.update();
      if (firstTime) {
        registration.addEventListener("updatefound", () => {
          console.log("App update found");
          $nuxt.$emit("update-found");
        });
      }
    }
  }
  setTimeout(
    () => checkForUpdate(context, err, false),
    UPDATE_CHECKER_INTERVAL
  );
}
